import User from "@/models/user.model";
import { ArtworkWrapper } from "@/types/artworksData";
import { Gallery } from "@/types/galleryData";
import { SpaceData } from "@/types/spaceData";
import { PerspectiveCamera, PointLight, Scene } from "three";
import { getFlashingEffectsEnabled } from "../../utils/visitorPreferences";
import Renderer from "./renderer/renderer";

let instance;

class AppData {
    public galleryData: Gallery;
    public spaceData: SpaceData;
    public userData: User;
    public artworksScene: Scene;
    public spaceScene: Scene;
    public camera: PerspectiveCamera;
    public renderService: Renderer;
    public physicsService: any;
    public videoList: any = [];
    public soundList: any = [];
    public strobeLights: PointLight[] = [];
    public flashingEffectsEnabled = getFlashingEffectsEnabled();
    public keyStrokes = {}
    public debugCamera: PerspectiveCamera;
    public debugCameraEnabled = false;
    public runtimeCameraHeight: number | null = null;
    public emissionModels: any = [];
    public listener: any;
    public main3DManager: any;
    public lookAtCameraModels: any = [];
    public skinnedMeshes: any = [];
    public viewerRotationActive = false;
    public restoreViewerRotation?: () => void;
    constructor() {
        if (instance) {
            return instance
        }
        instance = this
    }

    public setGalleryData(galleryData: Gallery) {
        this.galleryData = galleryData;
    }
    public setSpaceData(spaceData: SpaceData) {
        this.spaceData = spaceData;
    }

    public setUserData(userData: User) {
        this.userData = userData;
    }

    public setSpaceScene(spaceScene: Scene) {
        this.spaceScene = spaceScene;
    }
    public setArtworksScene(artworksScene: Scene) {
        this.artworksScene = artworksScene;
    }

    public setCamera(camera: PerspectiveCamera) {
        this.camera = camera;
    }

    public setMain3DManager(main3DManager: any) {
        this.main3DManager = main3DManager;
    }

    public clearData() {
        this.galleryData = null;
        this.spaceData = null;
        this.userData = null;
        this.artworksScene = null;
        this.spaceScene = null;
        this.camera = null;
        this.debugCamera = null;
        this.debugCameraEnabled = false;
        this.runtimeCameraHeight = null;
        this.renderService = null;
        this.physicsService = null;
        this.videoList = [];
        this.soundList = [];
        this.strobeLights = [];
        this.keyStrokes = {};
        this.emissionModels = [];
        this.lookAtCameraModels = [];
        this.skinnedMeshes = [];
        this.viewerRotationActive = false;
        this.restoreViewerRotation = undefined;
        this.main3DManager = null;
    }

}

export default AppData;
